import { api } from './client'

/** Per-brand identity served by the backend keyed off the request Host header. */
export interface BrandingConfig {
  siteName?: string | null
  tagline?: string | null
  logoUrl?: string | null
  favicon?: string | null
  /** Visual skin, e.g. 'luxury' — toggles a per-brand stylesheet. */
  skin?: string | null
  theme?: { primary?: string | null; accent?: string | null } | null
}

export interface DomainConfig {
  theme: Record<string, unknown> | null
  pwa: Record<string, unknown> | null
  branding: BrandingConfig | null
  /** Per-brand marketing content overrides, shaped like defaultContent (partial). */
  content: Record<string, unknown> | null
  /** CSS for a custom visual template, injected at runtime (empty for built-ins). */
  skinCss?: string
  analyticsConfigId: string | null
  tenantId: string | null
}

export const domainApi = {
  /**
   * Fetch the domain/brand config for the current host. The backend resolves
   * the tenant from the Host header (via domainRegistry), so no argument is
   * needed — the browser's own host determines the brand.
   */
  getConfig: () => api.get<DomainConfig>('/domain/config'),
}
